/**
 * "Legislação, Comunicações e Balizamento" — vírgula entre todos, "e" antes do
 * último. Enumerar unidade fraca é copy de venda, e "A, B, C" lido em voz alta
 * soa a relatório; a conjunção é o que faz a frase soar como alguém falando.
 *
 * Mora aqui desde que o checkout passou a nomear as unidades da pessoa, e não
 * só o painel: duas cópias divergiriam na primeira vez que alguém mexesse numa.
 */
export function listar(itens: string[]): string {
  if (itens.length <= 1) return itens[0] ?? ""
  return `${itens.slice(0, -1).join(", ")} e ${itens[itens.length - 1]}`
}
